module.exports = __webpack_public_path__ + "static/media/speakers.562aa1b4.png";